<template>
  <div class="Note">
    <div class="page-title">{{title}}</div>
    <ATable
      ref="table"
      v-loading="loading"
      buttons-width="300px"
      max-height="750px"
      :placeholder="placeholder"      
      :search_field="search_field"
      :data="filtered_items"
      :summaryTitleColumnIndex="1"
      :summaryFields="summaryFields"
      show-summary
      hide-button-insert
      hide-pagination
      border
      @row-click="handleClickRow"
    >
      <div slot="search">
        <div class="inline bold">입고구분</div>
        <div class="inline ml-default search_flag_field">
          <ASelector
            v-model="search_in_flag"
            valueField="value"
            labelField="label"
            :items="note_in_flags"
          />
        </div>
        <div class="inline ml-default bold">출고구분</div>
        <div class="inline ml-default search_flag_field">
          <ASelector
            v-model="search_out_flag"
            valueField="value"
            labelField="label"
            :items="note_out_flags"
          />
        </div>
        <div class="inline ml-default bold search_date_field">
          <ASelector
            v-model="search_date_field"
            valueField="value"
            labelField="label"
            :items="search_dates"
          />
        </div>
        <div class="inline ml-default">
          <APeriodSelector 
            ref="period" 
            :value="search_period"
            hide-select
            @change="handleChangePeriod" 
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
          >{{$t('button.search')}}(F5)</el-button>
        </div>
      </div>
      <el-table-column 
        type="index" 
        label="No" 
        :index="handleIndex" 
        :width="$width.index" 
      />
      <el-table-column 
        prop="number" 
        label="어음번호" 
        width="160" 
      />
      <el-table-column 
        prop="type_flag" 
        label="구분" 
        width="50"
        :formatter="resolveTypeFlag" 
      />
      <el-table-column 
        prop="pay_date" 
        label="지급일" 
        :width="$width.date"
      />
      <el-table-column
        prop="price"
        label="금액"
        class-name="cell-number"
        :formatter="util.numberFormat"
      />
      <el-table-column 
        prop="desc" 
        label="기록사항" 
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="in_date" 
        label="입고일" 
        :width="$width.date"
      />
      <el-table-column 
        prop="in_flag" 
        label="구분" 
        width="50"
        :formatter="resolveInFlag" 
      />
      <el-table-column 
        prop="in_customer_name" 
        label="입고처" 
        width="80"
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="out_date" 
        label="출고일" 
        :width="$width.date"
      />
      <el-table-column 
        prop="out_flag" 
        label="구분" 
        width="50"
        :formatter="resolveOutFlag" 
      />
      <el-table-column 
        prop="out_customer_name" 
        label="출고처" 
        width="80"
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="publish_date" 
        label="발행일" 
        :width="$width.date"
      />
      <el-table-column 
        prop="publisher" 
        label="발행자" 
        width="70"
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="bank_name" 
        label="발행은행" 
        width="80"
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="endorser1" 
        label="배서인1" 
        width="70"
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="endorser2" 
        label="배서인2" 
        width="70"
        show-overflow-tooltip 
      />
      <el-table-column 
        prop="endorser3" 
        label="배서인3" 
        width="70"
        show-overflow-tooltip 
      />
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <div slot="buttons">
        <el-button
          type="primary"
          :disabled="!has_grant_write"
          @click="handleClickCreate"
        >어음등록(F2)</el-button>
      </div>
    </ATable>
    <div class="flex row-splitter">
      <el-dialog
        top="0"
        custom-class="form-dialog"
        :title="title"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        :before-close="beforeClose"
        destroyOnClose
        @opened="handleOpened"
      >
        <NoteForm 
          ref="form" 
          noteFlag="in-out"
          :data="form_data"
          :has_grant_write="has_grant_write"
          @completed="handleCompleted"
        ></NoteForm>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import NoteForm from "@/spa/Common/NoteForm";

export default {
  name: "Note",
  mixins: [form_container, authority_level],
  components: { NoteForm },
  data() {
    return {
      title: this.$t('title.note'),
      loading: false,
      items_note: [],
      placeholder: "어음번호,입고처,출고처,발행처",
      search_field: ["number", "in_customer_name", "out_customer_name", "publisher"],
      search_period: {value: '1m'},
      date: this.util.getDate(),
      period: {},
      items: [],
      form_data: [],      
      dialogVisible: false,
      search_in_flag: null,
      search_out_flag: null,
      search_dates: [
        { value: 'pay_date', label: '지급일' },
        { value: 'in_date', label: '입고일' },
        { value: 'out_date', label: '출고일' },
        { value: 'publish_date', label: '발행일' },
      ],
      search_date_field: 'pay_date',
      summaryFields: ['price'],
    };
  },
  computed: {
    filtered_items() {
      return this.items.filter(item => {
        return (
          (this.search_in_flag? item.in_flag === this.search_in_flag: true) &&
          (this.search_out_flag? item.out_flag === this.search_out_flag: true)
        );
      })
    },
    note_in_flag() {
      return this.system.options.note_in_flag;
    },
    note_in_flags() {
      let items = this.util.clone(this.note_in_flag);
      items.splice(0, 0, { value: null, label: '전체'});
      return items;
    },
    note_out_flag() {
      return this.system.options.note_out_flag;
    },
    note_out_flags() {
      let items = this.util.clone(this.note_out_flag);
      items.splice(0, 0, { value: null, label: '전체'});
      return items;
    },
    has_grant_write() {
      return this.isWriteLevel('note');
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {    
    loadData() {
      this.loading = true;
      this.api.listNote(this.search_date_field, this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      this.dialogVisible = true;
    },      
    resolveTypeFlag(row, column, value) {
      let flag = this.system.options.note_type_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    resolveInFlag(row, column, value) {
      let flag = this.note_in_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    resolveOutFlag(row, column, value) {
      let flag = this.note_out_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    handleChangePeriod(period) {
      this.period = period;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickRow(data) {
      this.openDialog(data);
    },    
    handleClickCreate() {
      if (!this.has_grant_write) { return; }
      this.form_data = undefined; //추가생성시 초기화
      this.openDialog();
    },
    handleCompleted(result) {
      this.dialogVisible = false;
      this.form_data = undefined;
      if (!result) { return; }
      this.loadData();
    },
  }
};
</script>
<style lang="scss">
.Note {
  .search_flag_field {
    width: 80px;
  }
  .search_date_field {
    width: 100px;
  }
}

</style>
